import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import {map} from 'lodash';
import truncateHtml from '../../../utils/truncateHtml';

const eventParams =
  ({ isRecommendedShowsRow, cardID, display_name, entryIndex }) =>
    isRecommendedShowsRow
      ? ['Recommended Shows', 'Click', `${display_name} ${entryIndex + 1}`]
      : ['Aggregation', 'Click', `Card ${cardID}`];

const handleEntryClick = (props) => () => sendAnalyticsEvent(
  ...eventParams(props)
);

const MultiStoryRowEntries = ({ entries, ...props }) =>
  <ul>
    {
      map(entries, ({ display_name, path }, entryIndex) => (
        <li key={path}>
          <Link to={path}
            dangerouslySetInnerHTML={{ __html: truncateHtml(
              display_name,
              { length: 55, omission: '...' }
            ) }}
            onClick={handleEntryClick({ ...props, path, entryIndex })}
          />
        </li>
      ))
    }
  </ul>;

MultiStoryRowEntries.propTypes = {
  cardID: PropTypes.number.isRequired,
  entries: PropTypes.arrayOf(PropTypes.shape({
    display_name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }).isRequired).isRequired,
  isRecommendedShowsRow: PropTypes.bool.isRequired
};

export default MultiStoryRowEntries;
